import { useMemo } from 'react';

import type { MultiSelectOption } from '@rtkwlf/fenrir-react';
import type { QueryParamConfig } from 'use-query-params';

import { LabelLookupMultiSelectOptionParam } from '../label-lookup-multi-select-option-param/label-lookup-multi-select-option-param';

export const useLabelLookupMultiSelectOptionParam = (
  multiSelectOptions: { label: string; value: string }[] = [],
): QueryParamConfig<MultiSelectOption[] | undefined> => {
  return useMemo(() => {
    const optionLookupByValue = multiSelectOptions.reduce<
      Record<string, string>
    >((acc, { value, label }) => ({ ...acc, [value]: label }), {});

    return LabelLookupMultiSelectOptionParam(optionLookupByValue);
  }, [multiSelectOptions]);
};
